
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airbnb-market-data/[...place]",
      function () {
        return require("private-next-pages/airbnb-market-data/[...place].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airbnb-market-data/[...place]"])
      });
    }
  